import { useAvivaDispatch, useAvivaSelector } from "@redux/hook";
import { setModalViewState } from "@redux/slices/modal";

import { ModalViewConfig } from "./Modal-View-Config/modal-view-config";

function useModalView(): [boolean, Function] {
  const dispatch = useAvivaDispatch();
  const modalState: boolean = useAvivaSelector(
    (state) => state.modalView.isModalShow
  );
  function setModalState({
    isModalShow,
    ModalViewComponent,
  }: {
    isModalShow: boolean;
    ModalViewComponent: string;
  }) {
    if (!isModalShow) {
      setTimeout(() => {
        dispatch(setModalViewState({ isModalShow, ModalViewComponent }));
      }, 300);
    } else {
      dispatch(setModalViewState({ isModalShow, ModalViewComponent }));
    }
  }

  return [modalState, setModalState];
}

export { useModalView, ModalViewConfig };
